<template>
  <v-dialog v-model="dialog" :width="$vuetify.breakpoint.xs ? '90vw' : dialogWidth">
    <template v-slot:activator="{ on }">
      <v-btn :class="iconClass" :color="iconColor" icon dark :style="iconStyle" v-on="on">
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title :class="tclass" style="word-break: unset">
        <slot name="header">
          <h4 class="font-weight-regular"> {{ title }} </h4>
        </slot>
      </v-card-title>

      <v-card-text :class="cardTextClasses">
        <slot></slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :class="buttonClasses" :color="confirmColor" text @click="dialog = false">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "InformationDialogIcon",
    props: {
      confirmClass: {
        type: String,
        default: ''
      },
      confirmColor: {
        type: String,
        default: 'secondary'
      },
      confirmText: {
        type: String,
        default: 'Got It!'
      },
      // 5 Jun 2026 JCH: opt-in xs body shrink (see .info-dialog-text--xs); off by default so other dialogs are unaffected
      compactXs: {
        type: Boolean,
        default: false
      },
      dialogWidth: {
        default: 500
      },
      icon: {
        type: String,
        default: 'mdi-information-outline'
      },
      iconClass: {
        type: String,
      },
      iconColor: {
        type: String,
        default: 'grey'
      },
      iconStyle: {
        type: String,
      },
      // 12 May 2026 JCH: Apply caption typography on xs so dense dialogs stay readable on phones.
      compactBodyOnXs: {
        type: Boolean,
        default: false,
      },
      title: String,
      tclass: {
        type: String,
      },
    },
    computed: {
      buttonClasses() {// 31 Dec 2025 JCH use computed property for button classes
        const classes = ['informationDialogConfirm', this.confirmClass].filter(Boolean).join(' ');
        return classes;
      },
      // 6 Jun 2026 JCH: compactXs = tighter Edit Lists help; compactBodyOnXs = caption on xs (from test)
      cardTextClasses() {
        if (!this.$vuetify.breakpoint.xs) return '';
        if (this.compactXs) return 'body-2 info-dialog-text--xs';
        if (this.compactBodyOnXs) return 'caption';
        return '';
      },
    },
    data: () => ({
      dialog: false
    })
  }
</script>

<style scoped>
  /* 6 Jun 2026 JCH: xs-only compact body (<600px). 0.68rem vs body-2's 0.875rem; forced onto slotted p/li
     (not just the wrapper) so inheritance/specificity can't swallow it. Icons nudged down to match. */
  .info-dialog-text--xs { font-size: 0.68rem !important; line-height: 1.4; }
  .info-dialog-text--xs >>> p,
  .info-dialog-text--xs >>> li { font-size: 0.68rem !important; }
  .info-dialog-text--xs >>> .v-icon { font-size: 13px !important; }
</style>
